import { render } from "./cgu.vue?vue&type=template&id=7ce09dbe"
import script from "./cgu.js?vue&type=script&lang=js&external"
export * from "./cgu.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__